<template>
  <div class="user-selector-wrapper">
    <v-autocomplete
      :height="height ? height : 'auto'"
      attach
      :items="users"
      item-value="id"
      item-text="displayName"
      clearable
      :label="label"
      :hide-details="hideDetails"
      v-bind="$attrs"
      dense
      outlined
      :value="value"
      :multiple="multiple"
      @input="emitVal">
      <template #selection="{ item }">
        <user-avatar class="mr-4 my-2" :user="item" disableOpenLink :closable="multiple" @close="removeUser(item.id)"> </user-avatar>
      </template>
      <template #item="{ item }">
        <v-list-item-content>
          <user-avatar :user="item" disableOpenLink> </user-avatar>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
  import UserAvatar from '@Share/components/UserAvatar.vue';
  import { mapGetters } from 'vuex';
  export default {
    name: 'UserSelector',
    props: {
      label: {
        type: String,
        default: '',
      },
      value: {
        type: [String, Array],
        default: '',
      },
      multiple: {
        type: Boolean,
        default: false,
      },
      height: {
        type: String,
        default: 'auto',
      },
      hideDetails: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        
      };
    },
    computed:{
      ...mapGetters('USER', {
        userItems: 'GET_ENTRIES',
      }),
      currentTaskType: {
        get() {
          return this.$store.getters['TASK_MANAGER/GET_CURRENT_TASK_TYPE'];
        },
      },
      users(){        
        return this.currentTaskType?.users || this.userItems;
      }
    },
    mounted() {
      if (!this.users.length) this.$store.dispatch('USER/GET_USERS');
    },
    methods: {
      emitVal(val) {
        this.$emit('input', val);
      },
      removeUser(userId) {
        if (this.value && Array.isArray(this.value)) {
          this.$emit('input', this.value.filter(id => id !== userId));
        }
      },
    },
    components: {
      UserAvatar,
    },
  };
</script>
<style>
</style>